import Land from "./Land";

const MainStage = () => {
  return <Land />;
};

export default MainStage;
